<div class="container">
  <!-- Main Title -->
  <section class="section__title">
    <div>
      <h4 class="pretitle__h4">Área privada</h4>
      <h1>Animaciones</h1>
    </div>
  </section>
</div>
<!-- Content -->
<section class="bg-grey card-documents">
  <div class="container pt-2 pb-3">
    <div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 mt-2">
      <div class="col mb-3">
        <div class="card">
          <a [routerLink]="['/renault-zone/animation-action']" class="ratio ratio-16x9 bg-primary text-white">
            <h2 class="text-center d-flex align-items-center justify-content-center">Animaciones Red</h2>
          </a>
        </div>
      </div>
      <div class="col mb-3">
        <div class="card">
          <a [routerLink]="['/renault-zone/my-service']" class="ratio ratio-16x9 bg-gold text-dark">
            <h2 class="text-center d-flex align-items-center justify-content-center">My Service</h2>
          </a>
        </div>
      </div>
      <div class="col mb-3">
        <div class="card">
          <a [routerLink]="['/renault-zone/animation-dsp']" class="ratio ratio-16x9 bg-primarylight text-dark">
            <h2 class="text-center d-flex align-items-center justify-content-center">DSP</h2>
          </a>
        </div>
      </div>
    </div>
  </div>
</section>